import React from "react";

import HeroSection from "./HeroSection/HeroSection";

const Home = (): JSX.Element => {
  return <HeroSection />;
};

export default Home;
